import { Service } from '@angular/core';
import { jwtDecode } from 'jwt-decode';

interface JwtPayload {
  exp?: number;
  iss?: string;
  [key: string]: unknown;
}

/** Decodificacion y vigencia del JWT, equivalente al JwtService de FrontKordata. */
@Service()
export class JwtService {
  decodeToken(token: string): JwtPayload | null {
    try {
      return jwtDecode<JwtPayload>(token);
    } catch {
      return null;
    }
  }

  getTokenExpirationDate(token: string): Date | null {
    const decoded = this.decodeToken(token);
    if (!decoded?.exp) {
      return null;
    }
    const date = new Date(0);
    date.setUTCSeconds(decoded.exp);
    return date;
  }

  /** `userId` y `empresaId` viajan como string en el JWT de One. */
  obtenerClaimEntero(token: string | null, clave: string): number | null {
    if (!token) {
      return null;
    }
    const valor = this.decodeToken(token)?.[clave];
    const numero = typeof valor === 'number' ? valor : Number(valor);
    return Number.isInteger(numero) && numero > 0 ? numero : null;
  }

  isTokenExpired(token: string | null, offsetSeconds = 0): boolean {
    if (!token) {
      return true;
    }

    // Un token ilegible no sirve para autenticar; uno legible sin `exp` lo valida el backend.
    const decoded = this.decodeToken(token);
    if (decoded === null) {
      return true;
    }
    if (!decoded.exp) {
      return false;
    }

    const date = this.getTokenExpirationDate(token);
    return date !== null && date.valueOf() <= Date.now() + offsetSeconds * 1000;
  }
}
